import React from "react";
import RubyQuickFixesWidget from "./RubyQuickFixesWidget";

interface AskRubyBrandWidgetProps {
  activeTab?: string;
  onIssueFixed?: () => void;
}

const AskRubyBrandWidget: React.FC<AskRubyBrandWidgetProps> = ({ activeTab = "overview", onIssueFixed }) => (
  <RubyQuickFixesWidget cardId="brand-insight" activeTab={activeTab} onIssueFixed={onIssueFixed} />
);

export default AskRubyBrandWidget;
